"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// plugis
var md_utils_1 = require("./md-utils");
var markdown_it_imsize_1 = __importDefault(require("@steelydylan/markdown-it-imsize"));
var markdown_it_anchor_1 = __importDefault(require("markdown-it-anchor"));
var md_renderer_fence_1 = require("./md-renderer-fence");
var prism_1 = __importDefault(require("./prism"));
var mdContainer = require("markdown-it-container");
// options
var md_container_1 = require("./md-container");
var md_custom_block_1 = require("./md-custom-block");
md_utils_1.md.use(prism_1.default)
    .use(require("markdown-it-footnote"))
    .use(md_renderer_fence_1.rendererFence)
    .use(markdown_it_imsize_1.default)
    .use(require("markdown-it-task-lists"), { enabled: true })
    .use(markdown_it_anchor_1.default, { level: [1, 2, 3] })
    .use(require("markdown-it-inline-comments"))
    .use(require("markdown-it-link-attributes"), {
    pattern: /^(?!https:\/\/zenn\.dev\/)/,
    attrs: {
        rel: "nofollow",
    },
})
    .use(require("markdown-it-custom-block"), md_custom_block_1.optionCustomBlock)
    .use(mdContainer, "details", md_container_1.mdContainerDetails)
    .use(mdContainer, "message", md_container_1.mdContainerMessage)
    .use(require("markdown-it-texmath"), {
    engine: require("katex"),
    delimiters: "dollars",
    katexOptions: { macros: { "\\RR": "\\mathbb{R}" } },
});
// custom footnote
md_utils_1.md.renderer.rules.footnote_block_open = function () {
    return '<section class="footnotes">\n' +
        '<div class="footnotes-title"><img src="https://twemoji.maxcdn.com/2/svg/1f58b.svg" class="emoji footnotes-twemoji" loading="lazy" width="20" height="20">脚注</div>\n' +
        '<ol class="footnotes-list">\n';
};
exports.default = md_utils_1.md;
